import Api from 'src/api/Base'

class PostUserInfo extends Api {
  requestUrl = `/api/UserRequest/requestToJoin`

  method = 'POST'
}
export default PostUserInfo
